import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import BusinessPartnerEmployeeModel from '../../../models/BusinessPartnerEmployeeModel';
import DataService from "../../../services/data.service";
import AddBusinessPartnerPopup from '../Popups/Employee_popup_AddBusinessPartner';

interface Props {
    employeeId: number
}

const Employee_tab_BusinessPartners: React.FC<Props> = ({ employeeId }) => {
    const [data, setData] = useState<BusinessPartnerEmployeeModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, [employeeId]);

    function getTableData() {
        DataService.get<BusinessPartnerEmployeeModel[]>('api/v1/BusinessPartnerEmployees/ByEmployee/' + employeeId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData: BusinessPartnerEmployeeModel) {
        DataService.delete('api/v1/BusinessPartnerEmployees/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'businessPartnerId', visible: false },
        { title: 'Business-partner', dataProp: 'businessPartner.name', sort: 'asc' },
        { title: 'Workflow role', dataProp: 'functionalRole.name' },
    ];

    const { isAuthorizedFor } = useAuth();
    if (isAuthorizedFor(ApplicationFunctions.UpdateEmployee)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            }
        );
    }

    return (
        <>
            <DataTable
                name='dtEmployeeBusinessPartners'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Business-partner'
                navigateUrl='/plm/BusinessPartners/Details/'


            />
            {showPopup && <AddBusinessPartnerPopup employeeId={employeeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </>
    );
}
export default Employee_tab_BusinessPartners;